// Display-only physical units. Simulation stores canonical resource units,
// so existing saves stay compatible. 1 water unit = 10 L = 0.01 kL.
const WATER = new Set(["water", "raw_water", "potable_water", "wastewater"]);
const GASES = new Set(["oxygen", "hydrogen", "methane", "co2", "nitrogen", "argon", "carbon_monoxide"]);
const FOOD = new Set(["food", "raw_food", "processed_food", "fertilizer", "nutrients", "biomass"]);
const METALS = new Set(["metal_ore", "raw_ore", "iron", "aluminum", "copper", "silicon", "refined_metal", "regolith", "construction_material", "refinery_tailings"]);
export function resourceUnit(key) {
  if (WATER.has(key)) return { factor: 0.01, unit: "kL" };
  if (GASES.has(key)) return { factor: 1, unit: "kg" };
  if (FOOD.has(key)) return { factor: 1, unit: "kg" };
  if (METALS.has(key)) return { factor: 1, unit: "t" };
  if (key === "power") return { factor: 1, unit: "kWh" };
  if (key === "credits") return { factor: 1, unit: "cr" };
  return { factor: 1, unit: "units" };
}
export function formatResourceAmount(key, amount) {
  const { factor, unit } = resourceUnit(key);
  const value = Number(amount || 0) * factor;
  return `${value.toLocaleString(undefined, { maximumFractionDigits: Math.abs(value) < 10 ? 2 : 1 })} ${unit}`;
}
export function formatResourceRate(key, amountPerSecond) {
  // Display per simulated sol for meaningful values after life-support calibration.
  return `${formatResourceAmount(key, Number(amountPerSecond || 0) * 480)}/sol`;
}
